import React from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import { Element } from 'react-scroll';
import T from 'prop-types';
import { canUseDOM } from 'helpers';
import { connect } from 'react-redux';
import * as actions from 'actions';

import styles from './visibilitySensor.css';

if (canUseDOM) {
  var container = document.getElementById('sensorViewport');
}

class Sensor extends React.Component {
  onChange = (isVisible) => {
    if (this.props.change) {
      const {
        scrollPosition, color, scrollIndex, code,
      } = this.props;
      isVisible && scrollPosition(color, scrollIndex, code);
    }
  };

  render() {
    const {
      children, id, className, scrollIndex, position,
    } = this.props;
    const Component = children;
    return (
      <Element
        style={{
          position: position || 'relative',
        }}
        className={className}
        id={id}
        name={`scroll-${scrollIndex}`}
      >
        <VisibilitySensor
          scrollCheck
          scrollThrottle={100}
          intervalDelay={100}
          containment={canUseDOM ? container : null}
          onChange={this.onChange}
          minTopValue={0}
          offset={{
            top: 10,
            bottom: 10,
          }}
          delayedCall
          partialVisibility
        >
          <div className={styles.visibilitySensor} />
        </VisibilitySensor>
        {Component}
      </Element>
    );
  }
}

Sensor.defaultProps = {
  color: undefined,
  change: true,
  className: undefined,
};
Sensor.propTypes = {
  scrollPosition: T.func.isRequired,
  color: T.string,
  scrollIndex: T.number.isRequired,
  id: T.string.isRequired,
  className: T.string,
  position: T.string,
  change: T.bool,
};

const mapDispatchToProps = dispatch => ({
  scrollPosition: (color, scrollIndex, scrollCode) =>
    dispatch(actions.scrollPosition(color, scrollIndex, scrollCode)),
});

export default connect(null, mapDispatchToProps)(Sensor);



// WEBPACK FOOTER //
// ./src/components/modules/VisibilitySensor/VisibilitySensor.js